module.exports = require('../../../../../../../../utils/omit/belle.react-components/1/dist/impl.js');


// WEBPACK FOOTER //
// ./src/components/components/option/belle.react-components/1/~/bit/utils/omit/index.js